/* eslint-disable import/prefer-default-export */
import { createAsyncAction } from 'typesafe-actions';
import { PermissionsUserAccessResponse } from '@rootCommon/types/permission-access';

const getAdminTabsAccess = createAsyncAction(
  'GET_ADMIN_TABS_ACCESS_REQUEST',
  'GET_ADMIN_TABS_ACCESS_SUCCESS',
  'GET_ADMIN_TABS_ACCESS_FAILURE',
)<void, PermissionsUserAccessResponse, Error>();

export { getAdminTabsAccess };
